import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const SettingsTitle: React.FC = () => {
  const { t } = useTranslation();

  return <Text fw={500}>{t('REPORTS.MAILING_FORM.SETTINGS')}</Text>;
};
